/** 暂定城市：广州、杭州 */
export enum REGION_ENUM {
  GUANGZHOU = '4',
  HANGZHOU = '8',
}
export const REGION_LIST = [
  { value: REGION_ENUM.GUANGZHOU, label: '广州' },
  { value: REGION_ENUM.HANGZHOU, label: '杭州' },
];

/** 数字 是否 */
export enum YES_OR_NO_NUMBER_ENUM {
  YES = '1',
  NO = '0',
}
export const YES_OR_NO_NUMBER_LIST = [
  { value: YES_OR_NO_NUMBER_ENUM.YES, label: '是' },
  { value: YES_OR_NO_NUMBER_ENUM.NO, label: '否' },
];

/** 是否 */
export enum YES_OR_NO_ENUM {
  YES = 'YES',
  NO = 'NO',
}
export const YES_OR_NO_LIST = [
  { value: YES_OR_NO_ENUM.YES, label: '是' },
  { value: YES_OR_NO_ENUM.NO, label: '否' },
];

/** 加工订单 需求 状态描述 */
export enum PRODUCTION_DEMAND_STATUS_ENUM {
  /** 暂存 */
  CACHE = '10',
  /** 待核价 */
  WAITING_CHECK = '30',
  /** 待接单 */
  WAITING_ORDER = '50',
  /** 待签合同 */
  WAITING_SIGN = '60',
  /** 待录入资料 */
  WAITING_INPUT = '70',
  /** 录入资料中 */
  INPUTING = '80',
  /** 已完成 */
  COMPLETED = '90',
  /** 已取消 */
  CANCELED = '100',
}
export const PRODUCTION_DEMAND_STATUS_LIST = [
  { value: PRODUCTION_DEMAND_STATUS_ENUM.CACHE, label: '暂存' },
  { value: PRODUCTION_DEMAND_STATUS_ENUM.WAITING_CHECK, label: '待核价' },
  { value: PRODUCTION_DEMAND_STATUS_ENUM.WAITING_ORDER, label: '待接单' },
  { value: PRODUCTION_DEMAND_STATUS_ENUM.WAITING_SIGN, label: '待签合同' },
  { value: PRODUCTION_DEMAND_STATUS_ENUM.WAITING_INPUT, label: '待录入资料' },
  { value: PRODUCTION_DEMAND_STATUS_ENUM.INPUTING, label: '录入资料中' },
  { value: PRODUCTION_DEMAND_STATUS_ENUM.COMPLETED, label: '已完成' },
  { value: PRODUCTION_DEMAND_STATUS_ENUM.CANCELED, label: '已取消' },
];

/** 核价状态 */
export enum PRICING_STATUS_ENUM {
  /** 面辅料询价 */
  MATERIAL_INQUIRY_PRICE = '10',
  /** 询价待确认 */
  INQUIRY_PRICE_NOT_CONFIRM = '20',
  /** 用量待确认 */
  DOSAGE_NOT_CONFIRM = '30',
  /** 待核价 */
  WAIT_PRICING = '40',
  /** 核价中 */
  IN_PRICING = '50',
  /** 已核价 */
  ALREADY_PRICING = '60',
  /** 已取消 */
  CANCELED = '70',
}
export const PRICING_STATUS_LIST = [
  { value: PRICING_STATUS_ENUM.MATERIAL_INQUIRY_PRICE, label: '面辅料询价' },
  { value: PRICING_STATUS_ENUM.INQUIRY_PRICE_NOT_CONFIRM, label: '询价待确认' },
  { value: PRICING_STATUS_ENUM.DOSAGE_NOT_CONFIRM, label: '用量待确认' },
  { value: PRICING_STATUS_ENUM.WAIT_PRICING, label: '待核价' },
  { value: PRICING_STATUS_ENUM.IN_PRICING, label: '核价中' },
  { value: PRICING_STATUS_ENUM.ALREADY_PRICING, label: '已核价' },
  { value: PRICING_STATUS_ENUM.CANCELED, label: '已取消' },
];

/** 需求订单类型 */
export enum DEMAND_TASK_TYPE_ENUM {
  /** 打版订单 */
  PROTOTYPE = '1',
  /** 设计订单 */
  DESIGN = '2',
  /** 加工订单 */
  MACHINE = '3',
}
export const DEMAND_TASK_TYPE_LIST = [
  { value: DEMAND_TASK_TYPE_ENUM.PROTOTYPE, label: '打版订单' },
  { value: DEMAND_TASK_TYPE_ENUM.DESIGN, label: '设计订单' },
  { value: DEMAND_TASK_TYPE_ENUM.MACHINE, label: '加工订单' },
];
export const DEMAND_TASK_MACHINE_LIST = [
  { value: DEMAND_TASK_TYPE_ENUM.MACHINE, label: '加工订单' },
];

/** 打版、设计 转大货 */
export enum DEMAND_CHANGE_ENUM {
  /** 打版订单转大货 */
  OEM = '1',
  /** 设计订单转大货 */
  ODM = '2',
}
export const DEMAND_CHANGE_LIST = [
  { value: DEMAND_CHANGE_ENUM.OEM, label: 'OEM' },
  { value: DEMAND_CHANGE_ENUM.ODM, label: 'ODM' },
];
/** 订单来源 */
export const DEMAND_SOURCE_LIST = [
  { value: DEMAND_TASK_TYPE_ENUM.PROTOTYPE, label: '打版订单' },
  { value: DEMAND_TASK_TYPE_ENUM.DESIGN, label: '设计订单' },
];

/** 生产模式 */
export enum PRODUCTION_PATTERN_ENUM {
  FOB = '1',
  CMT = '2',
}
export const PRODUCTION_PATTERN_LIST = [
  { value: PRODUCTION_PATTERN_ENUM.FOB, label: 'FOB' },
  { value: PRODUCTION_PATTERN_ENUM.CMT, label: 'CMT' },
];
export const PRODUCTION_MODELS_LIST = [
  { value: PRODUCTION_PATTERN_ENUM.FOB, label: 'FOB（包工包料）' },
  { value: PRODUCTION_PATTERN_ENUM.CMT, label: 'CMT（来料加工）' },
];

/** 衣服单位 */
export const CLOTHES_UNIT_LIST = ['件', '套'];

/** 品质等级 */
export enum QUALITY_LEVEL_ENUM {
  /** A级 */
  A = 'A级',
  /** B级 */
  B = 'B级',
  /** C级 */
  C = 'C级',
}
export const QUALITY_LEVEL_LIST = [
  { value: QUALITY_LEVEL_ENUM.A, label: 'A级' },
  { value: QUALITY_LEVEL_ENUM.B, label: 'B级' },
  { value: QUALITY_LEVEL_ENUM.C, label: 'C级' },
];

/** 领料方式 */
export enum PICK_WAY_ENUM {
  /** 面料 */
  FABRIC = '1',
  /** 裁片 */
  CUT = '2',
}
export const PICK_WAY_LIST = [
  { value: PICK_WAY_ENUM.FABRIC, label: '面料' },
  { value: PICK_WAY_ENUM.CUT, label: '裁片' },
];

/** 款式季节 */
export enum SEASON_ENUM {
  /** 春款 */
  SPRING = '1',
  /** 夏款 */
  SUMMER = '2',
  /** 秋款 */
  AUTUMN = '3',
  /** 冬款 */
  WINTER = '4',
}
export const SEASON_LIST = [
  { value: SEASON_ENUM.SPRING, label: '春款' },
  { value: SEASON_ENUM.SUMMER, label: '夏款' },
  { value: SEASON_ENUM.AUTUMN, label: '秋款' },
  { value: SEASON_ENUM.WINTER, label: '冬款' },
];

/** 合同签署情况 */
export enum CONTRACT_STATUS_ENUM {
  /** 待签 */
  WAITING_SIGN = '1',
  /** 不签 */
  NO_SIGN = '2',
  /** 已签 */
  SIGNED = '3',
}
export const CONTRACT_STATUS_LIST = [
  // { value: CONTRACT_STATUS_ENUM.WAITING_SIGN, label: '待签' },
  { value: CONTRACT_STATUS_ENUM.NO_SIGN, label: '不签' },
  { value: CONTRACT_STATUS_ENUM.SIGNED, label: '已签' },
];

/** 资料录入 */
export enum DATA_INPUT_STATUS_ENUM {
  /** 待录入 */
  WAITING_INPUT = '1',
  /** 录入中 */
  INPUTING = '2',
  /** 已提交 */
  SUBMITTED = '3',
  /** 已取消 */
  CANCELED = '4',
}
export const DATA_INPUT_STATUS_LIST = [
  { value: DATA_INPUT_STATUS_ENUM.WAITING_INPUT, label: '待录入' },
  { value: DATA_INPUT_STATUS_ENUM.INPUTING, label: '录入中' },
  { value: DATA_INPUT_STATUS_ENUM.SUBMITTED, label: '已提交' },
  { value: DATA_INPUT_STATUS_ENUM.CANCELED, label: '已取消' },
];

/** 紧急程度 */
export enum EMERGENCY_LEVEL_ENUM {
  /** 普通 */
  NORMAL = '1',
  /** 紧急 */
  EMERGENCY = '2',
}
export const EMERGENCY_LEVEL_LIST = [
  { value: EMERGENCY_LEVEL_ENUM.NORMAL, label: '普通' },
  { value: EMERGENCY_LEVEL_ENUM.EMERGENCY, label: '紧急' },
];

/** 交付方式 */
export enum DELIVERY_TYPE_ENUM {
  /** 整单交付 */
  WHOLE = '1',
  /** 分批交付 */
  PARTIAL = '2',
}
export const DELIVERY_TYPE_LIST = [
  { value: DELIVERY_TYPE_ENUM.WHOLE, label: '整单交付' },
  { value: DELIVERY_TYPE_ENUM.PARTIAL, label: '分批交付' },
];

/** 生产环节 */
export enum PRODUCT_CHAIN_ENUM {
  /** 裁床 */
  CUTTING = '1',
  /** 车缝 */
  SEWING = '2',
  /** 尾部 */
  TAIL = '3',
}
export const PRODUCT_CHAIN_LIST = [
  { value: PRODUCT_CHAIN_ENUM.CUTTING, label: '裁床' },
  { value: PRODUCT_CHAIN_ENUM.SEWING, label: '车缝' },
  { value: PRODUCT_CHAIN_ENUM.TAIL, label: '尾部' },
];

/** 需求任务状态 */
export enum DEMAND_TASK_STATE_ENUM {
  /** 暂存 */
  CACHE = '10',
  /** 进行中 */
  PROCEED = '20',
  /** 已完成 */
  FINISHED = '30',
  /** 已取消 */
  CANCELED = '40',
}
export const DEMAND_TASK_STATE_LIST = [
  { value: DEMAND_TASK_STATE_ENUM.CACHE, label: '暂存' },
  { value: DEMAND_TASK_STATE_ENUM.PROCEED, label: '进行中' },
  { value: DEMAND_TASK_STATE_ENUM.FINISHED, label: '已完成' },
  { value: DEMAND_TASK_STATE_ENUM.CANCELED, label: '已取消' },
];
